"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationConstructDistinct = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const Keys_1 = require("@comunica/context-entries/lib/Keys");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
/**
 * A comunica Construct Distinct Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationConstructDistinct extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(action) {
        if (!action.context.has(Keys_1.KeysInitQuery.distinctConstruct)) {
            return (0, core_1.failTest)(`${this.name} was not enabled by the query.`);
        }
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const factory = new utils_algebra_1.AlgebraFactory();
        const operation = utils_algebra_1.algebraUtils.mapOperation(action.operation, {
            [utils_algebra_1.Algebra.Types.CONSTRUCT]: {
                preVisitor: () => ({ continue: false }),
                transform: constructOp => factory.createDistinct(factory.createConstruct(constructOp.input, constructOp.template)),
            },
        });
        return { operation, context: action.context.delete(Keys_1.KeysInitQuery.distinctConstruct) };
    }
}
exports.ActorOptimizeQueryOperationConstructDistinct = ActorOptimizeQueryOperationConstructDistinct;
//# sourceMappingURL=ActorOptimizeQueryOperationConstructDistinct.js.map